import { autocompleteFields } from './fragments/autocomplete-fields'

export const querySearchAutocompleteForProducts = /* GraphQL */ `
  query searchAutocompleteForProducts($term: String!) {
    autocomplete {
      products(term: $term) {
        ...autocompleteFields
      }
    }
  }

  ${autocompleteFields}
`
